
 <div class="content-wrapper pt-2">
  <section class="content">


    <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
      <div class="card-header">Employee Profile</div> 
      <form  [formGroup] ="employeeForm"  autocomplete="off" (ngSubmit)="saveButtonClick()" class="form-horizontal">
      <fieldset>
      <div class="card-body">

        <div class="row">
          <input readonly type="hidden" formControlName="id">      
        </div>
   

          <div class="row">
              <div class="col-md-6 controles-container">
                <mat-form-field>
                  <mat-label [ngClass]="{'dark-bg' : isDark }">Employee Id</mat-label> 
                  <input readonly type="text" formControlName="empId" matInput placeholder="Employee Id">   
                  <mat-error>Employee Id is required</mat-error>             
                  </mat-form-field>
              </div>
              <div class="col-md-6 controles-container">
                  <mat-form-field>
                    <mat-label [ngClass]="{'dark-bg' : isDark }">Employee No.</mat-label> 
                  <input type="text" formControlName="empNo" matInput placeholder="Employee No.">   
                  <mat-error>Employee number is required</mat-error>    
                  </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 controles-container">
                <mat-form-field>
                  <mat-label [ngClass]="{'dark-bg' : isDark }">Employee Name</mat-label> 
                  <input type="text" formControlName="empName" matInput placeholder="Employee Name">  
                  <mat-error>Emploloyee Name is required</mat-error>       
                  </mat-form-field> 
              </div>
              <div class="col-md-6 controles-container">
                <mat-form-field>
                  <mat-label [ngClass]="{'dark-bg' : isDark }">NIC</mat-label> 
                  <input type="text" formControlName="nic" matInput placeholder="NIC">      
                  </mat-form-field>
              </div>
            </div>


            <div class="row">
              <div class="col-md-6 controles-container">
                <mat-form-field>
                  <mat-label [ngClass]="{'dark-bg' : isDark }">Date of Birth</mat-label> 
                  <input  formControlName="dateOfBirth" matInput [matDatepicker]="picker" placeholder="Date of Birth">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field> 
              </div>
              <div class="col-md-6  controles-container">
                <mat-form-field>
                  <mat-label [ngClass]="{'dark-bg' : isDark }">Date of Joined</mat-label> 
                  <input   formControlName="dateOfJoined" matInput [matDatepicker]="dateOfJoinedPicker" placeholder="Date of Joined">
                  <mat-datepicker-toggle matSuffix [for]="dateOfJoinedPicker"></mat-datepicker-toggle>
                  <mat-datepicker #dateOfJoinedPicker></mat-datepicker>
                </mat-form-field> 
              </div>        
            </div>

        
            <div class="row">
              <div class="col-md-6 controles-container">
                <mat-form-field>
                  <mat-label [ngClass]="{'dark-bg' : isDark }">Permanent Address</mat-label> 
                  <textarea  formControlName="permanentAddress" matInput placeholder="Permanent Address"></textarea>
                </mat-form-field>
              </div>
              <div class="col-md-6 controles-container">
                <mat-form-field>
                  <mat-label [ngClass]="{'dark-bg' : isDark }">Postal Address</mat-label> 
                  <textarea  formControlName="postalAddress" matInput placeholder="Postal Address"></textarea>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6  controles-container">
                <mat-form-field>
                  <mat-label [ngClass]="{'dark-bg' : isDark }">Phone No.</mat-label> 
                  <input type="text" formControlName="phone" matInput placeholder="Phone No.">      
                  <mat-error>Phone is required</mat-error>  
                </mat-form-field> 
              </div>
              <div class="col-md-6 controles-container">
                <mat-form-field>
                  <mat-label [ngClass]="{'dark-bg' : isDark }">Email</mat-label> 
                  <input  type="text" formControlName="email" matInput placeholder="Email">      
                  <mat-error>Email must be a valid email address</mat-error>  
                </mat-form-field> 
              </div>
            </div>


            <div class="row">
              <div class="col-md-6  controles-container">
                <mat-form-field>
                  <mat-label [ngClass]="{'dark-bg' : isDark }">Department</mat-label> 
                  <mat-select  [ngClass]="{'dark-bg' : isDark }"  formControlName="department" placeholder="Department">
                    <mat-option>None</mat-option> 
                    <ng-container *ngFor="let dpt of departments">
                      <mat-option  value="{{dpt.id}}">
                        {{dpt.value}}
                      </mat-option>
                    </ng-container>                  
                  </mat-select>
                </mat-form-field>    
              </div>
              <div class="col-md-6  controles-container">
                <mat-form-field>
                  <mat-label [ngClass]="{'dark-bg' : isDark }">Position</mat-label> 
                  <input  type="text" formControlName="position" matInput placeholder="Position">      
                  </mat-form-field> 
              </div>
            </div>

              <div class="row">
                  <div class="col-md-6 controles-container">               
                  <div class="add-bottom-padding"> 
                    <label class="mb-3">Gender :&nbsp; &nbsp;</label> 
                    <mat-radio-group   aria-label="Select an option" placeholder="Gender" formControlName="gender" >
                      <mat-radio-button value="1">Male</mat-radio-button>
                      <mat-radio-button value="2">Female</mat-radio-button>
                    </mat-radio-group>                  
                  </div>
                </div>
              <div class="col-md-6  controles-container">
                <div class="add-bottom-padding"> 
                  <mat-checkbox  formControlName="status">Deactivated</mat-checkbox>     
                  </div>
              </div>                    
            </div>
     
        <div class="row">
          <button type="button" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>
          <button  *ngIf="crud_access.create"  type="submit"  [disabled]="isSaveBtnDisabled" class="btn btn-info ml-2">
           <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Save
          </button>
          <button type="button" class="btn btn-primary ml-2" routerLink="../employee-list"><i class="fa fa-table p-1"></i>Employee List</button>
          <button  type="button"  *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button>        
        </div>
        
        </div>                                
    </fieldset>
      </form>
    </div>

</section>
</div>

  
    
    
  